export default __webpack_public_path__ + "static/consultationBg3-f0a96582147c69c12d52302d0aaf6695.png";